import { module } from 'stereomodularjs';
import { html } from '../utils/environment'
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        let form = this.el;
        
        eventAdd(form, 'submit', (event) => {
            event.preventDefault();
            if (form.dataset.recaptchaSitekey) {
                let myThis = this;
                grecaptcha.execute(form.dataset.recaptchaSitekey, { action: 'submit' }).then(function (token) {
                    myThis.submitForm(form);
                });
            } else {
                this.submitForm(form);
            }
        });

        // Hide browser validation messages, focus the first invalid field
        form.addEventListener('invalid', function (e) {
            e.preventDefault();
            let invalidFields = form.querySelectorAll(':invalid');
            invalidFields[0].focus();
            form.classList.add('is-form-invalid');
        }, true);
    }

    nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    submitForm(form) {

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        let myThis = this;

        const formData = new FormData();

        let errorWrapper = form.querySelector('.js-error');
        let responseWrapper = form.querySelector('.js-response');
        let progressWrapper = form.querySelector('.js-progress');
        let submitButton = form.querySelector('.js-submit-button');
        let formhideonsuccess = form.dataset.formhideonsuccess;

        responseWrapper.classList.add('is-form-hidden');
        responseWrapper.innerHTML = '';
        progressWrapper.classList.remove('is-form-hidden');
        errorWrapper.innerHTML = '';
        submitButton.disabled = true;
        
        form.querySelectorAll('input, textarea, select').forEach(function (item) {
            if ((item.type == 'checkbox' || item.type == 'radio')&& !item.checked) return

            if (item.type == 'file') {
                for (let i = 0; i < item.files.length; i++) {
                    formData.append('files[]', item.files[i]);
                }
            } else {
                let value = item.type == 'select-multiple' ? myThis.getSelectValues(item) : item.value;
                formData.append(item.name, value)
            }
        })

        let headers = {
            'Accept': 'application/json',
            'X-CSRF-Token': form.dataset.csrfTokenValue,
            'X-Requested-With': 'XMLHttpRequest',
        };
        headers[form.dataset.csrfTokenName] = form.dataset.csrfTokenValue;

        fetch('/flexibleform/submit/' + form.dataset.entryid + '/' + form.dataset.fieldHandle, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            headers: headers,
            body: formData
        })
        .then(response => response.json())
        .then(data => { 
            if (data.status == 'success') {
                form.classList.add('is-form-success-ready');
                responseWrapper.closest('.js-zip').classList.add('is-zip-open');
                responseWrapper.innerHTML = this.nl2br(data.message);
                let responseEl = form.querySelector('.js-response');
                // for css animation
                setTimeout(()=>{
                    this.call('scrollToEl', {element: '#'+ form.getAttribute('id'), options : {offset : -240}} , 'Scroll')
                    formhideonsuccess ? form.querySelector(".js-form-fields__wrapper").classList.add('is-form-hidden') :
                    form.reset();
                    form.querySelector('.js-form-fields__wrapper').setAttribute('aria-disabled', 'true');
                    form.querySelector('.js-form-fields__wrapper').setAttribute('aria-hidden', 'true');
                }, 15);
                setTimeout(()=>{
                    document.activeElement.blur();
                    responseEl.focus();
                }, 500);
            } else {
                errorWrapper.innerHTML = this.nl2br(data.message);
            }

            progressWrapper.closest('.js-zip').classList.add('is-zip-open');
            submitButton.disabled = false;

        })
        .catch(error => {
            errorWrapper.innerHTML = this.nl2br(error.message);
            progressWrapper.closest('.js-zip').classList.add('is-zip-open');
            submitButton.disabled = false;
        });

    }

    getSelectValues(select) {
        var result = [];
        var options = select && select.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];

            if (opt.selected) {
                result.push(opt.value || opt.text);
            }
        }
        return result.join(', ');
    }

    destroy() {
        eventRemove(this.el, 'submit');
    }

}
